import React from "react";
import { useParams } from "react-router-dom";
import { useQueryParam } from "helpers/queryParam/useQueryParam";
import { PreviewForm } from "list/partials/forms/preview/PreviewForm";

export const PreviewFormPage: React.FC = ({}) => {
  const { uid } = useParams<{ uid: string }>();
  const [formUserToken] = useQueryParam("ems_user_token");
  return <PreviewForm uid={uid || ""} formUserToken={formUserToken} />;
};
